module.exports = __webpack_public_path__ + "static/media/29.ae66bb0e.jpg";